



































import { Component, Mixins } from "vue-property-decorator";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { MovableTextObjectStyleReader } from "../styleReaders";
import { DrawableItemEditorMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, TextDrawerPropertyEditableMixin, PainterPropertyEditableMixin, EditPainterPropertyEditableMixin } from "./mixins";
import TextStyleEditor from "../../../drawing/TextStyleEditor.vue";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    textStyleEditor: TextStyleEditor,
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
    quotationEditor: QuotationEditor,
  },
})
export default class MovableTextBoxPropertyEditor extends Mixins<
  PropertyEditableMixin
  & DrawableItemEditorMixin
  & DrawerPropertyEditableMixin
  & TextDrawerPropertyEditableMixin
  & PainterPropertyEditableMixin
  & EditPainterPropertyEditableMixin
>(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  TextDrawerPropertyEditableMixin,
  PainterPropertyEditableMixin,
  EditPainterPropertyEditableMixin,
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new MovableTextObjectStyleReader(configuration.style.document.editor.objects.movableTextBox);
  }
}
